<template>
  <div>
    <div class="content">
      <div class="content-main" style="min-height: 80vh;">
        <p class="content-title" style="padding-bottom: 16px;">先逛逛城市管理</p>
        <div class="content-button">
          <el-button type="primary" @click="addCity">添加城市</el-button>
        </div>
        <el-divider content-position="right">推荐城市</el-divider>
        <div>
          <el-tag
              v-for="(item,index) in cityList"
              :key="item.city"
              size="large"
              closable
              @close="delCity(index, item.id)"
              style="margin: 0 8px 8px 0"
          >
            {{ item.city }}
          </el-tag>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { getRecommendCityList, updateRecommendCityDel } from '../../api/url'
import { getFormData,postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import addCityDialog from "@/views/area/components/addCityDialog";
export default {
  name: "AreaCity",
  data() {
    return {
      cityList: []
    }
  },
  methods: {
    getPage() {
      getFormData(getRecommendCityList).then((data) => {
        if(data.code == 200) {
          this.cityList = data.data;
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
      })
    },

    addCity() {
      Dialog.open({
        title: '选择城市',
        component: addCityDialog,
        data: {
          cityList: this.cityList,
          width: '500px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    delCity(idx,id) {
      let param = {}
      param['id'] = id
      postFormData(updateRecommendCityDel, param).then((data) => {
        if(data.code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'success'
          })
          this.cityList.splice(idx, 1)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
      })
    },


  },
  created() {
    this.getPage()
  }

}
</script>

<style scoped>

</style>
